import { useParams } from '../../../router/hooks/useParams'
import { Page } from '../../../theme/components/Page'
import { PageSection } from '../../../theme/components/PageSection'
import { StyledCard } from '../../../theme/components/StyledCard'
import { StyledExpandCard } from '../../../theme/components/StyledExpandCard'
import { AanvraagDetail } from '../../components/AanvraagDetail'
import { Detail } from '../../components/Detail'
import { History } from '../../components/History'
import { Status } from '../../components/Status'
import { Werkzaamheden } from '../../components/Werkzaamheden'
import { useCombiOpdracht } from '../hooks/useCombiOpdracht'

export const CombiOpdracht = () => {
  /* v8 ignore next - TODO: missing coverage -- @preserve */
  const { id = '' } = useParams()
  const { data: opdracht, isLoading, isError } = useCombiOpdracht({ id })

  if (isLoading) {
    return
  }

  return (
    <Page
      title={[
        opdracht ? `${opdracht.opdrachtId}` : 'Combi opdracht',
        'Aansluiting',
      ]}
      breadcrumbs={[
        { label: 'Aansluiting', href: '/home', tooltip: 'CAPO home' },
        {
          label: 'Combi opdrachten',
          href: '/combiopdrachten',
          tooltip: 'Combi opdrachten overzicht',
        },
        {
          label: opdracht ? opdracht.opdrachtId : 'Combi opdracht',
        },
      ]}
    >
      <PageSection
        id="combiopdracht"
        heading={
          isError ? 'Combi opdracht niet gevonden' : `Combi opdracht ${id}`
        }
      />

      {opdracht?.opdrachtId && (
        <>
          <StyledCard title="Gegevens">
            <Detail opdracht={opdracht} />
          </StyledCard>
          <StyledExpandCard title="Status">
            <Status opdracht={opdracht} />
          </StyledExpandCard>
          <StyledExpandCard title="Werkzaamheden">
            <Werkzaamheden opdracht={opdracht} />
          </StyledExpandCard>
          <StyledExpandCard title="Aangevraagd">
            <AanvraagDetail opdracht={opdracht} />
          </StyledExpandCard>
          <StyledExpandCard title="Historie">
            <History history={opdracht.history} />
          </StyledExpandCard>
        </>
      )}
    </Page>
  )
}
